module.exports = __webpack_public_path__ + "static/Cumple30Exsis2xEN-581e781f5d4676861f6dce579d729f00.jpg";